import PropTypes from 'prop-types';

export default {
    openInNewTab: PropTypes.bool,
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/RelatedLinks/RelatedLink/propTypes.js